export default __webpack_public_path__ + "static/media/copy.f622509a.svg";